var render = function render(){var _vm=this,_c=_vm._self._c;return _c('json-crud',{attrs:{"data-source":_vm.dataSource,"headers":_vm.headers,"title-field":_vm.titleField,"title":_vm.$t('forms')}})
}
var staticRenderFns = []

export { render, staticRenderFns }